import Vue from 'vue';
import Component from 'vue-class-component';
import OrderTable from '../OrderTable/OrderTable';
import isIntoView from '@/api/isIntoView';
import { Orders, Order } from '@/types/order';
import REQ_URL from '@/consts/req-url';
import OrderSortPanel from '../OrderSortPanel/OrderSortPanel';
import OrderFilterPanel from '../OrderFilterPanel/OrderFilterPanel';
import { PagedResponse } from '@/types/response-data';
import { modalParams } from '@/types/state.modal';


interface FilterParams {
    search: string
    cid?: string
}

@Component({
    components: {
        OrderSortPanel,
        OrderTable,
        OrderFilterPanel
    }
})
export default class OrderListContainer extends Vue {
    loading = true
    showRepeatDialog = false
    repeatedOrderID = ''
    pageInfoPrev = {
        curr: 1,
        of: 1
    }
    pageInfo = {
        curr: 1,
        of: 1
    }
    sortBy = ''
    filterParams: FilterParams = {
        search: ''
    }
    viewListMode = 'grid'
    orders: Orders = []
    error = ''
    get pageVisible() {
        return this.$vuetify.breakpoint.xsOnly ? 6 : 7
    }
    get showFilterPanel() {
        return this.$store.state.profile.profileType === 'manager' && !this.$route.params.cid
    }
    /*get compViewListMode() {
        return this.$vuetify.breakpoint.xsOnly ? 'grid' : this.viewListMode
    }*/

    async filtering(needScroll = false) {
        this.loading = true
        try {
            let data = await this.$fetch<PagedResponse<Orders>>(REQ_URL.GET_ORDERS, {
                method: 'POST',
                body: JSON.stringify({
                    filterParams: {
                        ...this.filterParams,
                        cid: this.$route.params.cid
                    },
                    page: this.pageInfo.curr,
                    sortBy: this.sortBy
                })
            })
            if (data.body) {
                this.orders = data.body.pageContent
                if (data.body.pageInfo) {
                    this.pageInfoPrev.curr = this.pageInfo.curr = data.body.pageInfo.curr
                    this.pageInfoPrev.of = this.pageInfo.of = data.body.pageInfo.of
                }
                else this.pageInfo.curr = this.pageInfo.of = 1

                if (needScroll) {
                    let tb = document.getElementById('toolbar')
                    if (tb && !isIntoView('#orders')) {
                        this.$vuetify.goTo('#orders', {
                            duration: 300,
                            offset: (tb && tb.offsetHeight ? tb.offsetHeight : 0) + 30,
                            //easing: this.easing
                        })
                    }
                }
            }
            else throw new Error(data.error ? data.error : 'Ошибка соединения. Повторите позже.')
        } catch (error) {
            this.pageInfo.curr = this.pageInfoPrev.curr
            this.pageInfo.of = this.pageInfoPrev.of

            let errMsg: modalParams = {
                type: 'error',
                msg: error.message
            }
            this.$store.commit('modal:open', errMsg)
        }
        this.loading = false
    }
    updateFilterParams(e: FilterParams) {
        this.filterParams = e
        this.pageInfo.curr = 1
        this.filtering()
    }
    updateSortBy(e: string) {
        this.sortBy = e
        this.filtering()
    }
    updatePage(e: number) {
        this.pageInfo.curr = e;
        this.filtering(true)
    }
    repeatComplete(uniqueNumber: string) {
        this.showRepeatDialog = true
        this.repeatedOrderID = uniqueNumber
    }
    mounted() {
        this.filtering();
    }
}